import { useContext, useEffect, useState } from "react";
import { MessagePanelContainerWrapper } from "./MessagePanel.style";
import MessageListView from "./MessageListView";
import FilteredMessageListView from "./FilteredMessageListView";
import { ImmutableChat } from "@home-health-notify/domain/build/chat/ImmutableChat";
import {
  ChatContext,
  ChatMessagesProvider,
  FilteredChatMessagesProvider,
  FilteredChatProvider,
  UploadProgress,
} from "hhn-commons";
import { IFileAndCaption, MESSAGE_STATUS } from "@home-health-notify/domain";
import { UnsentMessagesGuardContext } from "../context/UnsentMessagesGuardContext";

interface MessagePanelContainerProps {
  fileProgressStatus?: UploadProgress;
  isUploadFailed: boolean;
  openFileDialog: () => void;
  onPasteFile: (fileList: IFileAndCaption[]) => Promise<void>;
}

const MessagePanelContainer = ({
  fileProgressStatus,
  isUploadFailed,
  openFileDialog,
  onPasteFile,
}: MessagePanelContainerProps) => {
  const [isSearchModeActive, setIsSearchModeActive] = useState(false);
  const { chat } = useContext(ChatContext);

  const [currentOpenChat, setCurrentOpenChat] = useState<
    ImmutableChat | undefined
  >(undefined);

  const { setHasUnsentMessages } = useContext(UnsentMessagesGuardContext);
  const hasUnsentMessages = !!chat?.messages.messages.some(message => {
    const { status } = message.getMessage();
    return (
      status === MESSAGE_STATUS.PENDING || status === MESSAGE_STATUS.FAILED
    );
  });

  useEffect(() => {
    setHasUnsentMessages(hasUnsentMessages);
    return () => setHasUnsentMessages(false);
  }, [hasUnsentMessages, setHasUnsentMessages]);

  useEffect(() => {
    if (chat && currentOpenChat?.chatInfo.id !== chat.chatInfo.id) {
      setCurrentOpenChat(chat);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat]);

  return (
    <MessagePanelContainerWrapper>
      {!isSearchModeActive && (
        <ChatMessagesProvider>
          <MessageListView
            onSearchFocus={() => {
              setIsSearchModeActive(true);
            }}
            fileProgressStatus={fileProgressStatus}
            isUploadFailed={isUploadFailed}
            openFileDialog={openFileDialog}
            onPasteFile={onPasteFile}
          />
        </ChatMessagesProvider>
      )}
      {isSearchModeActive && currentOpenChat && (
        <FilteredChatProvider openChat={currentOpenChat}>
          <FilteredChatMessagesProvider>
            <FilteredMessageListView
              onSearchClear={() => {
                setIsSearchModeActive(false);
              }}
              fileProgressStatus={
                fileProgressStatus ?? {
                  uploadPct: 0,
                  uploadedFiles: 0,
                  totalFiles: 0,
                }
              }
              isUploadFailed={isUploadFailed}
              openFileDialog={openFileDialog}
            />
          </FilteredChatMessagesProvider>
        </FilteredChatProvider>
      )}
    </MessagePanelContainerWrapper>
  );
};

export default MessagePanelContainer;
